module.exports = __webpack_public_path__ + "jp.svg?2dcb030e6eaf682476b0bfe61c04021e";